function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { default as MUITab } from '@mui/material/Tab';
const FRef = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement(MUITab, _extends({}, props, {
    ref: ref
  }));
});
export const Tab = props => {
  return /*#__PURE__*/React.createElement(FRef, props);
};
export default Tab;